import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {toggleLoader} from '../../shared/actions/setting';
import {getDashboardSummary, getUserCountByRole, getUserGrowth} from '../../utils/mainServices';
import DashboardSummaryCards from './dashboardSummaryCards';
import UsersByRoleBarChart from './usersByRoleBarChart';
import UserGrowthLineChart from './userGrowthLineChart';
import RoleDistributionDonutChart from './roleDistributionDonutChart';


const toRoleDistribution = (usersByRole) => {
  const totalUsers = usersByRole.reduce((sum, row) => sum + row.total, 0);
  return usersByRole.map((row) => ({
    roleId: row.roleId,
    roleName: row.roleName,
    percentage: totalUsers > 0 ? Math.round((row.total / totalUsers) * 1000) / 10 : 0,
  }));
};

const Dashboard = () => {
  const dispatch = useDispatch();
  const [summary, setSummary] = useState(null);
  const [usersByRole, setUsersByRole] = useState([]);
  const [userGrowth, setUserGrowth] = useState([]);
  const [roleDistribution, setRoleDistribution] = useState([]);

  useEffect(() => {
    const fetchAnalytics = async () => {
      dispatch(toggleLoader(true));

      try {
        const [summaryResponse, usersByRoleResponse, userGrowthResponse] = await Promise.all([
          getDashboardSummary(),
          getUserCountByRole(),
          getUserGrowth(12),
        ]);

        setSummary(summaryResponse.content || null);

        const usersByRoleContent = usersByRoleResponse.content || [];
        setUsersByRole(usersByRoleContent);
        setRoleDistribution(toRoleDistribution(usersByRoleContent));
        setUserGrowth(userGrowthResponse.content || []);
      } catch (error) {
        console.error('Error fetching dashboard analytics:', error);
        toast.error('Something went wrong while loading the dashboard');
      } finally {
        dispatch(toggleLoader(false));
      }
    };

    fetchAnalytics();
  }, [dispatch]);

  return (
    <div className="dashboard-page-container">
      <Container>
        <DashboardSummaryCards summary={summary}/>
        <div className="single-card p-a-16 dashboard-chart-card">
          <div className="dashboard-chart-title">Users by Role</div>
          <div className="dashboard-chart-subtitle">Total, active, and today's logins per role - top roles by user count.</div>
          <UsersByRoleBarChart data={usersByRole}/>
        </div>
        <Row>
          <Col md={8}>
            <div className="single-card p-a-16 dashboard-chart-card">
              <div className="dashboard-chart-title">User Growth (Last 12 Months)</div>
              <UserGrowthLineChart data={userGrowth}/>
            </div>
          </Col>
          <Col md={4}>
            <div className="single-card p-a-16 dashboard-chart-card">
              <div className="dashboard-chart-title">Role Distribution</div>
              <RoleDistributionDonutChart data={roleDistribution}/>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Dashboard;
